module.exports = __webpack_public_path__ + "img/5f_r_kandagawa@2x.530569d7.png";